export default "__VITE_ASSET__0722a9e6__"